// extracted by mini-css-extract-plugin
export var root = "B_tQ";
export var wrapper = "B_tR";
export var image = "B_tS d_w d_y d_W";
export var imageWithHeight = "B_tT";
export var crop = "B_tV";
export var round = "B_tW";
export var fixedHeight = "B_tX";